import Toast from "helper/toast";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "./use-auth";

export default function useHttp(isLoading = true) {
  const [loading, setLoading] = useState(isLoading);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const navigate = useNavigate();
  const AuthCTX = useAuth();

  const request = useCallback(
    async ({ url, title, values, isFile, isMulty }) => {
      isFile && setUploadProgress(0);
      isFile && setIsUploading(true);
      !isMulty && setLoading(true);
      var res = await url(values);
      !isMulty && setLoading(false);
      isFile && setIsUploading(false);

      if (!res.ok) {
        // if (res.status === 400) return AuthCTX.logout();

        if (res.data?.code) {
          switch (res.data.code) {
            case 1:
              return Toast({
                type: "custom-warn",
                title: "این کد برای حساب شما ثبت نشده است",
              });
            case 2:
              return Toast({
                type: "custom-warn",
                title: "کد تخفیف منقضی شده است",
              });
            case 3:
              return Toast({
                type: "custom-warn",
                title: "دفعات استفاده از این کد به اتمام رسیده است",
              });
            case 30:
              return Toast({
                type: "custom-warn",
                title: "شماره تماس نا معتبر است ",
              });
            case 600:
              return Toast({
                type: "custom-warn",
                title: "نام کاربری یا رمز عبور اشتباه است",
              });
            case 703:
              return Toast({
                type: "custom-warn",
                title: "لطفا چند ثانیه دیگر مجددا تلاش کنید",
              });
            case 705:
              return Toast({
                type: "custom-warn",
                title: "کد وارد شده نا معتبر است",
              });
            case 802:
              return Toast({
                type: "custom-warn",
                title: "این کد برای حساب شما ثبت نشده است",
              });
            case 963:
              return Toast({
                type: "custom-warn",
                title: "کد تخفیف منقضی شده است",
              });
            case 964:
              return Toast({
                type: "custom-warn",
                title: "کد وارد شده نا معتبر است",
              });
            case 851:
              return Toast({
                type: "custom-warn",
                title: "شما نمیتوانید بیشتر از موجودی محصول سفارش دهید",
              });
            case 891:
              AuthCTX.logout();
              return Toast({
                type: "custom-warn",
                title: res.data.reason_for_blocking,
                autoClose: 3000,
              });

            default:
              return Toast({ type: "err", title });
          }
        } else {
          // return Toast({ type: "err", title });
        }
      }

      return res.data;
    },
    []
  );

  return {
    request,
    loading,
    setLoading,
    uploadProgress,
    setUploadProgress,
    isUploading,
  };
}
